import React, { useState } from "react";

import { useQuery, useLazyQuery } from "@apollo/client";
import { useMutation } from "@apollo/client";
import get from "lodash/get";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import Notification from "shared/components/Notification";
import { CREATE_FOLDER } from "shared/graphql/mutations";
import { RULES } from "shared/graphql/rule/queries";
import { DEFAULT_VALUES, NAME_SPACES } from "shared/locals/constants";
import { PATHS } from "utils/constants";
import { useInfo } from "utils/hooks/info";

import View from "./View";

const Component = ({ setActiveStep, item }) => {
  const {
    commonInfo: { unknownProductCode },
  } = useInfo();

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { t: tError } = useTranslation(NAME_SPACES.ERRORS);
  const [warranty, setWarranty] = useState();

  const [getRules, query] = useLazyQuery(RULES);
  const queryWarranty = useQuery(RULES, {
    variables: {
      where: {
        invoiceLine: item.receiptLinekey,
        productCode: item.productCode || unknownProductCode,
        ruleType: "WARRANTY",
      },
    },
    onCompleted: (result) => {
      const warrantyCodeParams =
        result?.rules?.data?.warrantyTypes[0]?.warrantyCode;
      setWarranty(result?.rules?.data?.warrantyTypes[0]?.warrantyDesc);
      getRules({
        variables: {
          where: {
            invoiceLine: item.receiptLinekey,
            productCode: item.productCode || unknownProductCode,
            interventionType: item?.intervention.code,
            ruleType: "FAULT_CODES",
            warrantyCode: warrantyCodeParams,
          },
        },
      });
    },
  });

  const [createFolder] = useMutation(CREATE_FOLDER, {
    onCompleted: ({ createFolder: result }) => {
      const folderNum = get(result, "data.folderNum");
      history.push(
        folderNum
          ? PATHS.FILE.ADVANCEMENT.replace(":id", folderNum)
          : PATHS.FILE.HOME,
      );
    },
    onError: () => {
      setLoading(false);
      Notification.error({
        duration: DEFAULT_VALUES.NOTIFICATION_DURATION,
        message: tError("GENERIC"),
      });
    },
  });

  const onCreate = async (values) => {
    setLoading(true);
    const data = Object.entries(values).reduce(
      (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
      {},
    );
    await createFolder({
      variables: {
        data,
      },
    });
    setLoading(false);
  };

  return (
    <View
      setActiveStep={setActiveStep}
      query={query}
      onCreate={onCreate}
      product={item}
      loading={loading}
      warranty={warranty}
      queryWarranty={queryWarranty}
    />
  );
};

Component.propTypes = {
  item: PropTypes.shape({
    productCode: PropTypes.string.isRequired,
    intervention: PropTypes.shape({
      code: PropTypes.string.isRequired,
      desc: PropTypes.string,
    }).isRequired,
  }).isRequired,
  setActiveStep: PropTypes.func.isRequired,
};

Component.defaultProps = {};

export default Component;
